// extracted by mini-css-extract-plugin
module.exports = {"sportIcon":"Row_sportIcon__34Eyk"};